// Swap Free Control — SwapFreeConfigurationAppService contracts.

export enum ConfigurationType {
  Groups = 1,
  Logins = 2,
}

export enum SwapCalculationType {
  PositionBased = 0,
  NetVolume = 1,
}

export enum SwapDirection {
  Normal = 0,
  OnlyPay = 1,
  OnlyEarn = 2,
}

export enum SwapFreeConfigurationStatus {
  InActive = 0,
  Active = 1,
}

export interface ResultDto<T> {
  value: T;
  text: string;
}

export interface SwapFreeOptionsDto {
  directions: ResultDto<number>[];
  calculationTypes: ResultDto<number>[];
  statuses: ResultDto<number>[];
  types: ResultDto<number>[];
}

export interface SwapFreeConfigurationDto {
  details: string | null;
  name: string | null;
  type: number;
  scope: string;
  swapFreeDays: number;
  direction: number;
  directionText: string;
  calculationType: number;
  calculationTypeText: string;
  status: number;
  statusText: string;
  isActive: boolean;
  targetCount: number;
  targetsPreview: string[];
  exceptionCount: number;
  createdAt: string | null;
  updatedAt: string | null;
  user: string | null;
  id: string;
}

export interface SwapFreeConfigurationTargetDto {
  target: string;
  exceptions: number[];
  remove: string | null;
}

export interface SwapFreeTargetDto {
  selected: boolean;
  target: string;
  group: string | null;
  loginCount: number;
  exceptions: string | null;
}

export interface SwapFreeGroupExceptionsDto {
  group: string;
  logins: number[];
}

export interface HistoryDealDto {
  date: string;
  login: number;
  positionId: number;
  symbol: string | null;
  addedSwaps: number;
  currency: string | null;
}

export interface PaginatedInputDto {
  // Supplied by useServerDataTable at request time; optional so filter/extra-param
  // objects (e.g. { configurationId } / { filter }) satisfy the type.
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  search?: string;
  draw?: number;
}

export interface GetConfigurationsInput extends PaginatedInputDto {
  name?: string;
  status?: number;
  type?: number;
  // Column-search passthrough params (sent by useServerDataTable columnFilters).
  createdAt?: string;
  updatedAt?: string;
  scope?: string;
  swapFreeDays?: string;
  statusText?: string;
  directionText?: string;
  calculationTypeText?: string;
}

export interface GetConfigurationTargetsInput extends PaginatedInputDto {
  configurationId: string;
  target?: string;
}

export interface GetGroupTargetsInput extends PaginatedInputDto {
  filter?: string;
  target?: string;
}

export interface GetLoginTargetsInput extends PaginatedInputDto {
  filter?: string;
  target?: string;
}

export interface GetLoginsByGroupsInput extends PaginatedInputDto {
  groups: string[];
}

export interface GetHistoryDealsInput extends PaginatedInputDto {
  login?: number;
  symbol?: string;
  positionId?: number;
  currency?: string;
  startDate?: string;
  endDate?: string;
}

export interface CreateSwapFreeConfigurationFromTargetsInput {
  name: string;
  type: number;
  swapFreeDays: number;
  swapDirection: number;
  swapCalculationType: number;
  filter?: string;
  selectAllMatched: boolean;
  selectedGroups: string[];
  deselectedGroups: string[];
  loginNumbers: number[];
  deselectedLogins: number[];
  exceptionLogins: number[];
}

export interface UpdateSwapFreeConfigurationScalarsInput {
  id: string;
  name?: string;
  swapFreeDays: number;
  swapDirection: number;
  swapCalculationType: number;
}

export interface ApplySwapFreeTargetChangesInput {
  configurationId: string;
  addedTargets: string[];
  removedTargets: string[];
  groupExceptions: SwapFreeGroupExceptionsDto[];
}

export interface SetSwapFreeConfigurationStatusInput {
  id: string;
  isActive: boolean;
}

export interface DeleteSwapFreeConfigurationInput {
  id: string;
}
